const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts[0];
}

export let BASE_URL = '';
export const urlProfilePic = '';
export let ANALYTICS_API_URL = '';


if (getSubdomain() == 'localhost') {
    ANALYTICS_API_URL = 'http://localhost:3000/data';
    BASE_URL = 'http://localhost:3200/api';
}
else {
    ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
    BASE_URL = `${window.location.origin}/api`;
}

export const cdnUrl = 'https://cdn.game-lords.com/games/';


// WEBPACK FOOTER //
// ./src/constants/variables.js